import { useState } from "react";
import { Forward } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Spinner } from "@/components/States";

export default function AccountCard() {
  const { user, refreshUser } = useAuth();
  const [fwd, setFwd] = useState(user.forward_email || "");
  const [busy, setBusy] = useState(false);
  const save = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      const { data } = await api.put("/auth/me/notifications", { forward_email: fwd.trim() || null });
      toast.success(data.forward_email ? `Copies will go to ${data.forward_email}` : "Forwarding turned off");
      setFwd(data.forward_email || ""); refreshUser?.();
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <section className="rounded-xl border bg-card p-5" data-testid="account-card">
      <h3 className="flex items-center gap-2 font-semibold"><Forward className="h-4 w-4 text-muted-foreground" />Forward my E.L.M emails</h3>
      <p className="mt-1 text-sm text-muted-foreground">Signed in as <span className="font-medium text-foreground">{user.email}</span>. Add a personal address and every email E.L.M sends you — reminders, approvals, digests, sign-in codes — is also delivered there, marked [Fwd].</p>
      <form onSubmit={save} className="mt-4 flex flex-wrap items-end gap-2">
        <div className="min-w-[260px] flex-1 space-y-1.5"><Label htmlFor="fwd-email">Personal email</Label><Input id="fwd-email" type="email" value={fwd} onChange={(e) => setFwd(e.target.value)} placeholder="you@personal.com" data-testid="forward-email-input" /></div>
        <Button type="submit" className="rounded-full" disabled={busy} data-testid="forward-email-save">{busy ? <Spinner /> : fwd.trim() ? "Save" : user.forward_email ? "Turn off" : "Save"}</Button>
      </form>
      {user.forward_email && <p className="mt-2 text-xs text-muted-foreground" data-testid="forward-email-status">Currently forwarding to {user.forward_email}.</p>}
    </section>
  );
}
